import axios from "axios";
import store from "@/store/store";

const ENDPOINT_HOST = process.env.VUE_APP_API_ENDPOINT
function fetchData(endpoint, requestType, requestBody, resolve, reject) {
  let token = "";
  if (store.state.loggedInUser) {
    token = store.state.loggedInUser.api_token.token;
  }

  const headers = {
    "Content-Type": "application/json",
    "Cache-Control": "no-cache",
    "Auth-Token": token,
    "Content-Encoding": 'gzip'
  };
  const axiosConfig = {
    method: requestType.toLowerCase(),
    url: endpoint,
    headers
  };

  if (requestBody) {
    if (["get"].includes(requestType.toLowerCase())) {
      axiosConfig.params = requestBody;
    } else {
      axiosConfig.data = requestBody;
    }
  }

  return axios(axiosConfig)
    .then(response => {
      resolve(response.data.response);
    })
    .catch(error => {
      console.log(error)
      if (
        error.response.data.response.code !== null &&
        error.response.data.response.code !== undefined &&
        error.response.data.response.code === 401
      ) {
        store.commit("removeLoggedInUser");
        store.commit("setSessionTimout", true);
        location.reload();
      }
      reject(error.response.data.response.errors);
    });
}

export { fetchData, ENDPOINT_HOST };



// WEBPACK FOOTER //
// ./src/api/api_helper.js